import { Calendra2,ExpiryEffectivityDate } from "@common/DatePicker";
import ReactSelect from "@common/ReactSelect";
import { DEFAULT_INPUTFIELD_LENGTH, FIELD_TYPE, REGEX_NUMBER_WITH_TWO_DECIMAL, EFFECTIVITY_EXPIRY_INTERVAL,BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID } from "@src/config/constant";
import React, { useEffect, useRef, useState } from "react";
import bellIcon from '../../../styles/webroot/images/bell.png';
import MMVModal from "../MMVModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import moment from 'moment';
import ToggleSwitch from "./ToggleSwitch";
import {FUEL_TYPE, VEHICLE_TYPE, CREATE_PAGE_INDEX, IS_ACC_TOGGLE, KTP_ID_INPUT_LIMIT, REGEX_EMAIL_VALIDATION, HIDE_FOR_COMPANY, POLICY_HOLDER, FIELD_ORDER, SAME_AS_KTP, VEHICLE_CONDITION,IS_HQ, INSURANCE_TYPE_COMPREHENSIVE, INSURANCE_TYPE_TLO} from "@src/config/id/constant";
import { getBrandList, getParentModelList, getVersionList, setNewMMVlist,getOldCarPrice, getCityList, getLocalityList} from "@store/slices/commonId";
import { saveInsurance } from "@src/store/slices/insurance";
import * as HELPER from '@src/config/helper'
import { getMasterConfigID, getReporteeID } from '@src/store/slices/common';
import { fetchPermanentLocality } from "./functions/common.fn";
import { useLanguage } from "@src/context/LanguageContext";
import { ROLE } from "@src/config/id/constant";
import secureStorage from "@src/config/encrypt";
import { getEstimatedCarPrice } from "@src/store/slices/insuranceId";

type EngineCapacityOption = {
    value: number;
    label: string;
};

export default function DynamicFormFieldId(props: any) {

    const {setLoading,sectionIndex,isEdit, requestData,setAddonState,setRequestData, insuranceValues, setInsuranceValues} = props

    const [refresh, setRefresh] = useState<any>(1)
    const platePrefillKeyRef = useRef<string>("");
    const estimatedCarPriceKeyRef = useRef<string>("");
    const isManualTsiRef = useRef(false);
    const [showMMVPopup, setShowMMVPopup] = useState(false)
    const [mmvModalType, setMMVModalType] = useState('make')
    const commonState = useSelector((state: any) => state.common)
    const commonIdState = useSelector((state: any) => state.commonId)
    const insuranceState = useSelector((state: any) => state.insurance)
    const pastSixMonths = new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate())
    const [minExpiryDate, setMinExpiryDate] = useState(moment().toDate())
    const [carPrice, setCarPrice] = useState<any>({})
    const [tenureYear, setTenureYear] = useState(1);
    const dispatch: any = useDispatch()
    const {translations} = useLanguage();
    const policyHolderValue = requestData?.policy_holder; 
    const isCompany = policyHolderValue === POLICY_HOLDER.COMPANY;
    const authUserInfo = secureStorage.getItem("authAgentUserInfo") || {};
    const roleId = authUserInfo?.user_data?.role_id || authUserInfo?.role_id;

    const getTenureValue = (tenureFieldValue?: any) => {
        const resolvedValue = typeof tenureFieldValue === "object" ? tenureFieldValue?.value: tenureFieldValue;
        const numericValue = Math.max(1, Number(resolvedValue) || 1);
        return Math.min(5, numericValue);
    };

    // tenure year + staring date
    const getInsuranceEndingDate = (startDateValue: any, tenureFieldValue?: any) => {
        if (!startDateValue) return "";

        const parsedStartDate = moment(startDateValue);
        if (!parsedStartDate.isValid()) return "";

        // Same calendar day/month as start (e.g. 26 Jun 2025 → 26 Jun 2030 for 5y tenure); clone avoids mutating the original moment.
        return parsedStartDate.clone().add(getTenureValue(tenureFieldValue), "years").toDate();
    };

    const sanitizeInsuranceValues = (values: any[], selectedTenure?: number) => {
        const totalYears = selectedTenure || tenureYear;
        let hasPreviousTlo = false;

        return Array.from({ length: totalYears }, (_, index) => {
            const selectedValue = values[index];
            const normalizedValue = Number(selectedValue);

            if (hasPreviousTlo) {
                return INSURANCE_TYPE_TLO;
            }

            if (normalizedValue === INSURANCE_TYPE_TLO) {
                hasPreviousTlo = true;
                return INSURANCE_TYPE_TLO;
            }
            return selectedValue;
        });
    };

    const syncEditInsuranceValues = (values: any[], selectedTenure?: number) => {
        const totalYears = selectedTenure || tenureYear;

        return Array.from({ length: totalYears }, (_, index) => {
            const selectedValue = values[index];

            if (selectedValue !== undefined && selectedValue !== null && selectedValue !== "") {
                return selectedValue;
            }

            return values.slice(0, index).some((value: any) => Number(value) === INSURANCE_TYPE_TLO)
                ? INSURANCE_TYPE_TLO
                : selectedValue;
        });
    };

    const hasPreviousTloSelection = (repeatIndex: number, selectedValues: any[] = insuranceValues) => {
        return selectedValues.slice(0, repeatIndex).some((selectedValue: any) => Number(selectedValue) === INSURANCE_TYPE_TLO);
    };

    const getOrdinalYearLabel = (yearNumber: number) => {
        const remainderOfTen = yearNumber % 10;
        const remainderOfHundred = yearNumber % 100;

        if (remainderOfTen === 1 && remainderOfHundred !== 11) return `${yearNumber}st Year`;
        if (remainderOfTen === 2 && remainderOfHundred !== 12) return `${yearNumber}nd Year`;
        if (remainderOfTen === 3 && remainderOfHundred !== 13) return `${yearNumber}rd Year`;

        return `${yearNumber}th Year`;
    };

    const getOptionList = (fieldItem: any) => {  
        let options:Record<string,any>= fieldItem.options        
        if(fieldItem?.dynamicOptions){
            options = fieldItem?.dynamicOptions
        }
        else if (fieldItem.name === "copy_of_insurance") {
            let yes_no = commonState.common.YesAndNo
            options = yes_no
        }
        else if (fieldItem.name === 'per_province' || fieldItem.name === 'cur_province' ) {            
            let tempList: any = []
            commonIdState.state?.forEach((item: any) => {
                let param = { label: item.label, value: +item?.value }
                tempList.push(param)
            })
            options = tempList
        }
       
        else if (fieldItem.name === "per_city" || fieldItem.name === "cur_city") {
            let fieldProvinceName = fieldItem.name === "per_city" ? 'per_province' : "cur_province";

            let regionItem = getFieldItem(fieldProvinceName);

            let value = typeof regionItem?.value === 'object' ? regionItem?.value?.value : regionItem?.value;
            let cityList = fieldItem?.dynamicOptions?.length
                ? fieldItem.dynamicOptions
                : commonIdState.stateWithCity?.filter((item: any) => +item.id === +value)?.[0]?.['city_list'];
            let tempList: any = []
            cityList?.forEach((item: any) => {
                const numericValue = Number(item?.value);
                const optionValue = Number.isFinite(numericValue) ? numericValue : item?.id;
                let param = { label: item.label || item.value, value: +optionValue }
                tempList.push(param)
            })
            options = tempList
        }
        else if (fieldItem.name === "per_district" || fieldItem.name === "cur_district") {
            options = fieldItem?.dynamicOptions || fieldItem?.options || []
        }
        // gender

        else if (fieldItem.name === "gender") {
            options = commonState.common.gender;
        }

        else if (fieldItem.name === "city_birth") {
            options = commonIdState.city
        }
        // tenure
        else if (fieldItem?.name === "tenure") {
            options = (commonState?.common?.tenure_year || [])?.filter((opt: any) => {
                const val = typeof opt?.value === "object" ? opt?.value?.value : opt?.value;
                return Number(val) <= 5;
            })
        }

        else if(!fieldItem?.dynamicOptions && fieldItem?.parent_depedencies && !isEdit){
            options =[];
        }
        else if(fieldItem?.master_data_key && commonState?.common?.[fieldItem?.master_data_key]){
             options =  commonState?.common?.[fieldItem?.master_data_key]
        }else if(!fieldItem?.master_data_key && commonState?.common?.[fieldItem?.name]){
            options =  commonState?.common?.[fieldItem?.name]
        }

        if(isEdit && fieldItem.name==='vehicle_type'){
         let vehicleCategoryItem = getFieldItem("vehicle_category");
         let categoryId = typeof vehicleCategoryItem?.value === "object" ? vehicleCategoryItem?.value?.value : vehicleCategoryItem?.value
         options = options.filter((item: any) => item?.category_id === categoryId)
            
        }
        return options
    }

    const fetchMMV = async (type:string='make',parentValue?:number) => {
      let fnName = getBrandList;
      let params: Record<string, any> = {};
      let categoryId = 0;
      let vehicleTypeItem = getFieldItem("vehicle_type");

      categoryId = vehicleTypeItem?.value?.category_id || 0
  
      if(isEdit){
        let vehicleCategoryItem = getFieldItem("vehicle_category");
        categoryId = typeof vehicleCategoryItem?.value === "object" ? vehicleCategoryItem?.value?.value : vehicleCategoryItem?.value
      }
      
      if(categoryId){
        params.category_id = categoryId;
    
        if (vehicleTypeItem?.value?.value === VEHICLE_TYPE.EV) {
            params["fuel_type"] = FUEL_TYPE.EV;
        }
        if (vehicleTypeItem?.value?.value === VEHICLE_TYPE.HYBRID) {
            params["fuel_type"] = FUEL_TYPE.HYBRID;
        }
        if(type==='model'){
            params.make = parentValue
            fnName = getParentModelList
        }
        if(type==='version'){
            params.make = commonIdState?.newMMVlist?.make_id?.value
            params.model = parentValue
            fnName = getVersionList
        }
    
        if(type==='make' && vehicleTypeItem?.value?.value==commonIdState?.newMMVlist?.vehicle_type_id){
            return
        }else{
            dispatch(setNewMMVlist({vehicle_type_id:params.category_id}))
        }
        setLoading(true);
        dispatch(fnName(params)).then((response: any) => {
            setLoading(false);
        });
      }
    };

    const setEngineCapacity = (element: any) => {
        const vehicleType = getFieldItem('vehicle_classification')
        if ([BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleType?.value?.value)) {
            const engineCapacity = getFieldItem('engine_capacity')
            if(element.engine_capacity){
                engineCapacity.value = engineCapacity?.options.find((e:EngineCapacityOption) => e.value === element.engine_capacity)
            }else{
                engineCapacity.value = "";
            }
        }
    };

    const isShowDynamicField = (detail: any) => {
        if (detail?.field_show) {
            const splitType = detail.field_show.split('/');
            if (splitType.length > 1) {
                const expectedValues = splitType[1].includes('@') ? splitType[1].split('@') : [splitType[1]];
                const filterFieldItem = props?.fields?.find((each: any) => each.name === splitType[0]);
                const actualValue = String(filterFieldItem?.value?.value ?? filterFieldItem?.value);
                if(expectedValues.includes(actualValue)){
                    return true;
                }
                else return false;
            }
        }
        return !!detail?.['is_show'];
    };

    const isEnable = (fieldItem: any) => {
        return fieldItem.is_enable
    }

    const getFieldValue = (fieldItem: any, changedKey?: string, changedValue?: any) => {
        if(fieldItem.name==='total_fmv'){
            const carFmvValue = changedKey === 'car_fmv' ? changedValue : getFieldItem('car_fmv')?.value;
            const accPriceValue = changedKey === 'acc_price' ? changedValue : getFieldItem('acc_price')?.value;
            const totalFmv = (Number(carFmvValue) || 0) + (Number(accPriceValue) || 0)
            return totalFmv
            
        }else{
            return fieldItem.value || ''
        }
        
    }

    const isEngineCapacityField = (fieldItem: any) => {
        return fieldItem?.name === 'engine_capacity';
    };

    const onChangeText = (fieldItem: any, text: any) => {
        if(fieldItem?.type===FIELD_TYPE.CURRENCY){
            text = HELPER.removeCurrencyFormattingId(text)
        }
        if (isEngineCapacityField(fieldItem)) {
            text = String(text ?? '').replace(/\D/g, '');
        }
        if (props.sectionIndex === CREATE_PAGE_INDEX.CREATE) {
            return updateItem(props.sectionIndex, fieldItem.name, text)
        }else{
    
            const trimmedValue = text?.toString().trim();

            switch (fieldItem.name) {

                case 'ktp_id': {

                    if (text.length > KTP_ID_INPUT_LIMIT) return;

                    if (!/^\d{16}$/.test(trimmedValue)) {
                        return updateDocItem(
                            fieldItem,
                            text,
                            translations?.CREATE_APP?.KTP_NO_ERR
                        );
                    }

                    return updateDocItem(fieldItem, text, "");
                }
                case 'npwp_no': {

                    // npwp 
                    if (isCompany) {
                        const previous = fieldItem.value || ''

                        if (text.length < previous.length) {
                            return updateDocItem(fieldItem, text, "");
                        }

                        const digits = text.replace(/\D/g, '').substring(0, 15);
                        // NPWP format
                        const formatted = HELPER.formatNPWP(digits);
                        return updateDocItem(
                            fieldItem,
                            formatted,
                            ""
                        );
                    }

                    return updateDocItem(fieldItem, text, "");
                }

                case 'email': {
                    const isValid = REGEX_EMAIL_VALIDATION.test(trimmedValue);

                    return updateDocItem(
                        fieldItem,
                        text,
                        isValid ? "" : translations?.CREATE_APP?.EMAIL_ERR
                    );
                }

                case 'mobile': {
                    if (text.length > 13) {
                        text = fieldItem.value;
                    }

                    const isValid = /^8\d{7,12}$/.test(trimmedValue);

                    return updateDocItem(
                        fieldItem,
                        text,
                        isValid
                            ? ""
                            : translations?.CREATE_APP?.MOBILE_ERR
                    );
                }

                case 'cur_rt':
                case 'per_rt':
                case 'cur_rw':
                case 'per_rw': {
                    // only digits allow
                    let digits = text.replace(/\D/g, '');

                    // allow only 3 digit
                    if (digits.length > 3) return;

                    // decide error message based on field
                    const isRT = ['cur_rt', 'per_rt'].includes(fieldItem.name);

                    let errorMsg = "";
                    if (digits.length < 3) {
                        errorMsg = isRT ? translations?.CREATE_APP?.RT_ERR : translations?.CREATE_APP?.RW_ERR;
                    }
                    return updateDocItem(fieldItem, digits, errorMsg);
                }


                case 'plate_number': {
                    const normalized = String(text ?? '').toUpperCase().replace(/^\s+/, '');
                    let formatted = normalized;
                    if (platePrefix) {
                        const prefixWithSpace = `${platePrefix} `;
                        let suffix = "";
                        if (normalized.startsWith(prefixWithSpace)) {
                            suffix = normalized.slice(prefixWithSpace.length);
                        } else if (normalized.startsWith(platePrefix)) {
                            suffix = normalized.slice(platePrefix.length);
                        } else if (normalized.length < platePrefix.length) {
                            suffix = "";
                        } else {
                            suffix = normalized;
                        }
                        suffix = suffix.replace(/\s+/g, '');
                        formatted = suffix ? `${platePrefix} ${suffix}` : platePrefix;
                    } else {
                        formatted = normalized.replace(/\s+/g, '');
                    }
                    return updateDocItem(fieldItem, formatted, getPlateError(formatted));
                }

                case 'machine_number':
                case 'chassis_number':
                case 'color':
                case 'plate_number': {
                    const upper = trimmedValue.toUpperCase();
                    return updateDocItem(fieldItem, upper, "");
                }
                case 'per_postal_code':
                case 'cur_postal_code': {
                    // Allow only numeric digits
                    let digits = text.replace(/\D/g, '');

                    // Maximum 5 digits
                    if (digits.length > 5) return;

                    let errorMsg = "";

                    // Show error until exactly 5 digits are entered
                    if (digits.length < 5) {
                        errorMsg = translations?.CREATE_APP?.POSTAL_ERROR
                    }

                    return updateDocItem(fieldItem, digits, errorMsg);
                }
                default:
                    updateDocItem(fieldItem, text);
            }

           updateDocItem(fieldItem, text);
        }
    }

    const getVehicleConditionValue = () => {
        const raw = requestData?.vehicle_condition;
        return typeof raw === "object" ? raw?.value : raw;
    };

    const getPlateError = (value: string) => {
        const plateValue = String(value || '').trim().toUpperCase();
        const prefix = String(platePrefix || '').trim().toUpperCase().split(/\s+/)[0] || '';
        if (!plateValue) {
            return "";
        }
        const hasDigits = /\d/.test(plateValue);
        if (prefix) {
            if (plateValue === prefix) {
                return "";
            }
        } else if (!hasDigits) {
            return "";
        }
        // const vehicleConditionValue = getVehicleConditionValue();
        // if (+vehicleConditionValue === VEHICLE_CONDITION.USED) {
        //     if (!/^[A-Z]{1,2}\s?\d+(?:\s?[A-Za-z]+)?$/.test(plateValue)) {
        //         return translations?.CREATE_APP?.PLATE_NO_ERR || 'Invalid plate number';
        //     }
        // }
        // if (+vehicleConditionValue === VEHICLE_CONDITION.NEW) {
        //     if (!plateValue) {
        //         return translations?.CREATE_APP?.PLATE_NO_ERR || 'Invalid plate number';
        //     }
        // }
        if (!plateValue) {
            return translations?.CREATE_APP?.PLATE_NO_ERR || 'Invalid plate number';
        }
        return "";
   };

    const getFieldItem = (key: any) => {
        let filterItem = props?.fields?.filter((item: any) => item.name === key)?.[0]
        return filterItem
    }

    const fetchReportees = async (params: any) => {
        setLoading(true);
        try {
            const res = await dispatch(getReporteeID(params));
            return Array.isArray(res)
                ? res.map((row: any) => ({
                    label: row?.name,
                    value: row?.id,
                    role_id: row?.sfa_role_id,
                }))
                : [];
        } finally {
            setLoading(false);
        }
    };

    const carFmv = Number(getFieldItem('car_fmv')?.value) || 0;
    const isTenPercent = (value: number) => {
        const tenPercent = carFmv * 0.10;
        return value <= tenPercent;
    };


    const updateItem = (sectionIndex: number, key: string, value: any) => {
        
        let bstkAge = 0;
        const getComparableValue = (val: any) => (typeof val === "object" ? val?.value : val);
        const currentValue = getComparableValue(getFieldItem(key)?.value);
        const nextValue = getComparableValue(value);
        const shouldResetVehicle = (key === "vehicle_type" || key === "vehicle_category") && currentValue !== nextValue;
        
        const shouldUpdateInsuranceEndingDate = ["insurance_starting_date", "tenure"].includes(key);
        const insuranceStartDateValue = key === "insurance_starting_date" ? value : getFieldItem("insurance_starting_date")?.value;
        const selectedTenureValue = key === "tenure" ? value : getFieldItem("tenure")?.value;
        const insuranceEndingDate = shouldUpdateInsuranceEndingDate ? getInsuranceEndingDate(insuranceStartDateValue, selectedTenureValue) : "";

        if (shouldResetVehicle) {
            dispatch(setNewMMVlist({ make_id: {}, model_id: {}, version_id: {}, vehicle_type_id: undefined }));

            const clearedInsurance = { ...(insuranceState?.createInsurance || {}) };
            const keysToClear = [
                "make",
                "make_name",
                "model",
                "model_name",
                "version",
                "version_name",
                "parent_model_id",
                "parent_model_name",
            ];
            keysToClear.forEach((k) => {
                delete clearedInsurance[k];
            });
            dispatch(saveInsurance(clearedInsurance));
        }
        props?.setSectionItem((prev: any[]) =>
            prev?.map((section: any, sIdx: number) => {
            if (sIdx !== sectionIndex) return section;

            const updatedSection = { ...section };

            const fields = updatedSection?.blocks?.[0]?.fields || [];
            let childDependencies: string[] = [];

            const updatedFields = fields.map((row: any) => {
                let errorMessage = translations?.COMMON_MSG?.NOT_BLANK;
                // for update every filed value
                if (row.name === key) {
                
                    if(key==='bstk_insurer_date'){
                       bstkAge = HELPER.getDayDiffFromToday(value);       
                    }
                    
                    if(key==='acc_price'){
                      
                        setAddonState({});

                        if(!isTenPercent(value)) {
                            errorMessage =translations?.CREATE_APP?.ACC_PRICE_ERR;
                        }else{
                            errorMessage = '';
                        }  
                        
                        return {
                            ...row,
                            value: value,
                            error_message:errorMessage
                        };
                    }
                  
                    if(key==='rule_engine' || key==='car_fmv'){
                        setAddonState({});
                    }
                    if(key==='car_fmv'){
                        isManualTsiRef.current = !(value === "" || Number(value) === 0);
                    }
                    if(key==='vehicle' && !getFieldItem('vehicle_type')?.value?.value){
                        errorMessage = translations?.CREATE_APP?.VEHICLE_CLICK_ERR;
                        value=""
                    }
                    if(key==='vehicle' && getFieldItem('vehicle_type')?.value?.value){
                        errorMessage = '';
                        value=""
                    }
                    childDependencies = row.child_depedencies || [];
                    
                    return {
                        ...row,
                        value: value,
                        error_message:!value ? errorMessage:""
                    };
                }
                if(key==="version" && row.name==='engine_capacity'){
                    return {
                        ...row,
                        value: commonIdState?.newMMVlist?.version_id?.engine_capacity,
                        error_message:row.error_message?'':''
                    }
                    
                }
                if(row.name==='bstk_age'){
                    const bstk_insurer_date = getFieldItem('bstk_insurer_date');
                    if(bstk_insurer_date?.value){
                        if(!bstkAge) bstkAge = HELPER.getDayDiffFromToday(typeof bstk_insurer_date?.value==='string'?new Date(bstk_insurer_date?.value):bstk_insurer_date?.value);
                    }
                    return {
                        ...row,
                        value:bstkAge
                    }
                }
                if(row.name==='total_fmv'){
                    const totalFmvValue = getFieldValue(row, key, value);
                    return {
                        ...row,
                        value: totalFmvValue
                    }
                }

                if(row.name==='plate_area_type'){

                    let plateArea = getFieldItem('plate_area')?.value;
                    let plateAreaTypeId = plateArea?.plate_area_type;
                    if(isEdit)  plateAreaTypeId = commonState?.common?.plate_area?.find((row:any)=>row.value===plateArea)?.plate_area_type
                    
                    return {
                        ...row,
                        value: plateAreaTypeId,
                    }
                }

                if (row.name === "insurance_ending_date") {
                    return {
                        ...row,
                        value: shouldUpdateInsuranceEndingDate ? insuranceEndingDate : row.value,
                        is_enable: false,
                        error_message: "",
                    };
                }

                if (shouldResetVehicle && row.name === "vehicle") {
                    return {
                        ...row,
                        error_message: "",
                        value: "",
                    };
                }

                if(row.name==='vehicle' && row?.value){
                    return {
                        ...row,
                        error_message:""
                    }
                }
               
                // Child dependency  clear error and update options
                if (childDependencies.includes(row.name)) {

                    let options:Record<string,any>= row.options        
                    if(row?.master_data_key && commonState?.common?.[row?.master_data_key]){
                        options =  commonState?.common?.[row?.master_data_key]
                    }else if(!row?.master_data_key && commonState?.common?.[row?.name]){
                       options =  commonState?.common?.[row?.name]
                    }
                    
                    if(row.name==="vehicle_type"){
                        options =  options?.filter((op:any)=>op.category_id===value.value);
                    }

                    return {
                    ...row,
                    error_message: '',
                    value:'',
                    dynamicOptions:options
                    };
                }
                return row;
            });

            updatedSection.blocks = [
                {
                ...updatedSection.blocks[0],
                fields: updatedFields,
                },
            ];
            return updatedSection;
            })
        );
    };



    const onValueSelect = (fieldItem: any, event: any, repeatIndex?: any) => {
        const { name } = fieldItem;
        if(name ==="tenure"){
        const nextTenureYear = getTenureValue(event);
        setTenureYear(nextTenureYear);
        setInsuranceValues((prev: any[]) => isEdit ? syncEditInsuranceValues(prev, nextTenureYear) : sanitizeInsuranceValues(prev, nextTenureYear));
        }
        // for multiple year insurance type
        if (name === "insurance_type") {
            if (
                hasPreviousTloSelection(Number(repeatIndex)) &&
                Number(event?.value) === INSURANCE_TYPE_COMPREHENSIVE
            ) {
                return;
            }

            const updated = [...insuranceValues];
            updated[repeatIndex] = event.value;
            const sanitizedValues = sanitizeInsuranceValues(updated);
            const hasInsuranceTypeForEveryYear = sanitizedValues.every((selectedValue: any) =>
                selectedValue !== undefined && selectedValue !== null && selectedValue !== ""
            );
            if (hasInsuranceTypeForEveryYear) {
                fieldItem.error_message = "";
            }
            setInsuranceValues(sanitizedValues);
            //return;
        }

        // ToggleSwitch
        if (fieldItem.name === "per_sameas_cur") {
            onChangeCheckbox(fieldItem, event);
            return;
        }

        if (props.sectionIndex === CREATE_PAGE_INDEX.DOC) {

            const isDependentField = FIELD_ORDER.some(order => name.endsWith(order));

            if (isDependentField) {
                const updatedSectionItem = updateFieldAndResetDependents(
                    props.sectionItem,
                    name,
                    event
                );

                props.setSectionItem(updatedSectionItem);

                switch (name) {
                    case 'per_province':
                        fetchPermanentCity(fieldItem, event);
                        break;
                    case 'cur_province':
                        fetchCurrentCity(fieldItem, event);
                        break;
                    case 'per_city':
                        fetchPermanentLocality(fieldItem, event);
                        break;
                    case 'cur_city':
                        fetchCurrentLocality(fieldItem, event);
                        break;
                    default:
                        break;
                }
                return;
            }

            updateDocItem(fieldItem, event);
        }

        if (props.sectionIndex === CREATE_PAGE_INDEX.CREATE) {
            if (fieldItem.name === "bm_id") {
                updateItem(props.sectionIndex, fieldItem.name, event);

                props?.setSectionItem((prev: any[]) =>
                    prev?.map((section: any, sIdx: number) => {
                        if (sIdx !== props.sectionIndex) return section;

                        const updatedSection = { ...section };
                        const fields = updatedSection?.blocks?.[0]?.fields || [];

                        updatedSection.blocks = [
                            {
                                ...updatedSection.blocks[0],
                                fields: fields.map((row: any) =>
                                    row.name === "lead_on_behalf_user_id"
                                        ? {
                                            ...row,
                                            value: "",
                                            error_message: "",
                                            dynamicOptions: [],
                                        }
                                        : row
                                ),
                            },
                        ];

                        return updatedSection;
                    })
                );

                if (event?.value) {
                    fetchReportees({
                        role_id: ROLE.BM,
                        user_id: event.value,
                    }).then((agents) => {
                        props?.setSectionItem((prev: any[]) =>
                            prev?.map((section: any, sIdx: number) => {
                                if (sIdx !== props.sectionIndex) return section;

                                const updatedSection = { ...section };
                                const fields = updatedSection?.blocks?.[0]?.fields || [];

                                updatedSection.blocks = [
                                    {
                                        ...updatedSection.blocks[0],
                                        fields: fields.map((row: any) =>
                                            row.name === "lead_on_behalf_user_id"
                                                ? {
                                                    ...row,
                                                    dynamicOptions: agents?.filter(
                                                        (item: any) => item?.role_id === ROLE.AGENT
                                                    ),
                                                }
                                                : row
                                        ),
                                    },
                                ];

                                return updatedSection;
                            })
                        );
                    });
                }
                return;
            }
            updateItem(props.sectionIndex, fieldItem.name, event);
        }
    }

    const handleDependency=(fieldItem:any)=>{
        if(fieldItem.parent_depedencies){
            const updatedSec = structuredClone(props.sectionItem)   
            for (let i = 0; i < updatedSec?.[props.sectionIndex]?.blocks?.[0]?.fields.length; i++) {
                const parant = getFieldItem(fieldItem.parent_depedencies)  
                if(!parant?.value && updatedSec[props.sectionIndex].blocks[0].fields[i].name === fieldItem.name){
                    updatedSec[props.sectionIndex].blocks[0].fields[i].error_message =`please select ${parant.label?.toLowerCase()} first`
                }else if(parant?.value && fieldItem.name === 'vehicle'){
                    setShowMMVPopup(true)
                }
            }
            props.setSectionItem(updatedSec)
        }
        
    }
    useEffect(() => {
        if(showMMVPopup){
            fetchMMV(mmvModalType)
        }
    },[showMMVPopup])    

    useEffect(() => {
        const selectedTenure = getFieldItem("tenure")?.value;
        const nextTenureYear = getTenureValue(selectedTenure);

        if (nextTenureYear !== tenureYear) {
            setTenureYear(nextTenureYear);
        }
       
        setInsuranceValues && setInsuranceValues((prev: any[]) => isEdit ? syncEditInsuranceValues(prev, nextTenureYear) : sanitizeInsuranceValues(prev, nextTenureYear));
    }, [props.fields, tenureYear])

    const rowClass = (props.rowClass) ? props.rowClass : "col-md-4"

    const expiryDateField = props.fields?.find((item: any) => item.name === "expiry_date");
    const effectivityDateField = props.fields?.find((item: any) => item.name === "effectivity_date");
    const expiryDateValue = expiryDateField?.value;
    let effectivityDateValue = effectivityDateField?.value ? new Date(effectivityDateField.value) : null;

    if (effectivityDateValue) {
        // If time is missing (00:00:00), set the current time
        const now = new Date();
        if (
            effectivityDateValue.getHours() === 0 &&
            effectivityDateValue.getMinutes() === 0 &&
            effectivityDateValue.getSeconds() === 0
        ) {
            effectivityDateValue.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
        }
    } 

    const getEstimatedCarPricePayload = () => {
        const makeYear = getFieldItem('make_year')?.value?.value || requestData?.make_year;
        const vehicleCategory = getFieldItem('vehicle_category')?.value?.value || getFieldItem('vehicle_category')?.value || requestData?.vehicle_category;
        const vehicleType = getFieldItem('vehicle_type')?.value?.value || getFieldItem('vehicle_type')?.value || requestData?.vehicle_type;
        const plateArea = getFieldItem('plate_area')?.value?.value || getFieldItem('plate_area')?.value || requestData?.plate_area;
        const makeName = commonIdState?.newMMVlist?.make_id?.label || requestData?.make_name;
        const parentModelName = commonIdState?.newMMVlist?.model_id?.label || requestData?.parent_model_name;
        const versionName = commonIdState?.newMMVlist?.version_id?.label || requestData?.version_name;

        if (!(makeYear && vehicleCategory && vehicleType && plateArea && makeName && parentModelName && versionName)) {
            return null;
        }

        return {
            vehicle_category: Number(vehicleCategory),
            vehicle_type: Number(vehicleType),
            make_name: makeName,
            parent_model_name: parentModelName,
            version_name: versionName,
            make_year: Number(makeYear),
            plate_area: Number(plateArea)
        };
    };
    
    const getCarPrice = (params: Record<string, any>) => {
        if (params) {
            setLoading(true);
            getEstimatedCarPrice(params).then((response: any) => {
                if(response?.status===200){
                    const estimatedData = response?.data || {};
                    const recommendedTSI = Number(estimatedData?.recommendedTSI) || 0;
                    const accessoryPrice = Number(getFieldItem('acc_price')?.value) || 0;
                    const currentCarFmv = Number(getFieldItem('car_fmv')?.value) || 0;
                    const nextCarFmv = isManualTsiRef.current ? currentCarFmv : recommendedTSI;
                    const tsiRequiredMessage = translations?.COMMON_MSG?.NOT_BLANK || translations?.COMMON_MSG?.REQUIRED || "This field is required";

                    props.setRequestData((prev: any) => ({
                        ...prev,
                        confidenceScore: estimatedData?.confidenceScore,
                    }));

                    setCarPrice({
                        min_price: Number(estimatedData?.minTSI) || 0,
                        max_price: Number(estimatedData?.maxTSI) || 0,
                    });

                    props.setSectionItem((prev: any[]) =>
                        prev?.map((section: any, sIdx: number) => {
                            if (sIdx !== CREATE_PAGE_INDEX.CREATE) return section;

                            const updatedSection = { ...section };
                            const fields = updatedSection?.blocks?.[0]?.fields || [];

                            updatedSection.blocks = [
                                {
                                    ...updatedSection.blocks[0],
                                    fields: fields.map((row: any) => {
                                        if (row.name === 'car_fmv') {
                                            return {
                                                ...row,
                                                value: nextCarFmv,
                                                error_message: nextCarFmv === 0 ? tsiRequiredMessage : "",
                                            };
                                        }

                                        if (row.name === 'total_fmv') {
                                            return {
                                                ...row,
                                                value: nextCarFmv + accessoryPrice,
                                            };
                                        }

                                        return row;
                                    }),
                                },
                            ];

                            return updatedSection;
                        })
                    );
                }
                setLoading(false);
            });
        }
    }

    const updateDocItem = (fieldItem: any, value: any,errorMessage:string='') => {
        const updatedSectionItem = structuredClone(props.sectionItem);
        
        for (let i = 0; i < updatedSectionItem.length; i++) {
            const field = updatedSectionItem[i].fields;
            for (let j = 0; j < field?.length; j++) {
                const subField = field[j]
                if (fieldItem.name === subField.name) {
                    subField.value = value
                    subField['error_message'] = errorMessage;

                    const toggleField = field.find((f:any) => f.name === 'per_sameas_cur');
                    
                    
                if ((toggleField?.value === SAME_AS_KTP || toggleField?.value === true) && subField.name.startsWith('per_')) {
                    const curFieldName = subField.name.replace('per_', 'cur_');
                    const curField = field.find((f:any) => f.name === curFieldName);
                    if (curField) {
                        curField.value = value;
                        curField.error_message = '';
                        //curField.error_msg = '';
                    }
                }
                //if(subField.value) subField['error_message'] = "";
                }
            }
        }
        props.setSectionItem(updatedSectionItem);
    };

    
    const KEYS_WITHOUT_IDS = ['fuel_type','transmission'];
    const NUMBER_KEYS = ['bstk_age','engine_capacity']

 
    const onChangeCheckbox = (fieldItem?: any, toggleValue?: number) => {

        const isChecked = toggleValue === IS_ACC_TOGGLE.ACTIVE;
        

        const updatedSectionItem = structuredClone(props.sectionItem);

        for (let i = 0; i < updatedSectionItem.length; i++) {
            const fields = updatedSectionItem[i].fields;

            // first update toggle value
            for (let f of fields) {
                if (f.name === 'per_sameas_cur') {
                    f.value = isChecked;
                }
            }

            // now handle address copy
            fields.forEach((f: any) => {

                if (f.name.startsWith('cur_')) {

                    const perKey = f.name.replace('cur_', 'per_');
                    const perField = fields.find((x: any) => x.name === perKey);

                    if (isChecked && perField) {
                        f.value = perField.value;
                        f.is_enable = false;
                    } else {
                        f.is_enable = true;
                    }

                    f.error_message = '';
                    f.error_msg = '';
                }

            });
        }

        props.setSectionItem(updatedSectionItem);
    };

    const toSelectOptions = (list: any[] = []) => {
        return list.map((item: any) => ({
            label: item.label || item.value,
            value: +(Number.isFinite(Number(item?.value)) ? item.value : item?.id),
        }));
    };

    const setAddressOptions = (prefixes: string[], fieldName: 'city' | 'district', options: any[]) => {
        props.setSectionItem((prev: any[]) => {
            const updatedSectionItem = structuredClone(prev);

            for (const section of updatedSectionItem) {
                const fields = section?.fields || [];
                for (const prefix of prefixes) {
                    const field = fields.find((item: any) => item.name === `${prefix}_${fieldName}`);
                    if (field) {
                        field.options = options;
                        field.dynamicOptions = options;
                        field.error_message = "";
                        field.error_msg = "";
                    }
                }
            }

            return updatedSectionItem;
        });
    };

    const isSameAsSelected = () => {
        const sameAsField = getFieldItem('per_sameas_cur');
        return sameAsField?.value === true || sameAsField?.value === SAME_AS_KTP;
    };

    const fetchPermanentCity = async (fieldItem?: any, event?: any) => {
        const stateId = event?.value || fieldItem?.value?.value || fieldItem?.value;
        if (!stateId) return;

        setLoading(true);
        const response: any = await dispatch(getCityList({ state: [stateId] }));
        const cityOptions = response?.data ? toSelectOptions(response.data) : [];
        const prefixes = isSameAsSelected() ? ['per', 'cur'] : ['per'];
        setAddressOptions(prefixes, 'city', cityOptions);
        setLoading(false);
    };

    const fetchCurrentCity = async (fieldItem?: any, event?: any) => {
        const stateId = event?.value || fieldItem?.value?.value || fieldItem?.value;
        if (!stateId) return;

        setLoading(true);
        const response: any = await dispatch(getCityList({ state: [stateId] }));
        const cityOptions = response?.data ? toSelectOptions(response.data) : [];
        setAddressOptions(['cur'], 'city', cityOptions);
        setLoading(false);
    };

    const fetchPermanentLocality = async (fieldItem?: any, event?: any) => {
        const cityId = event?.value || fieldItem?.value?.value || fieldItem?.value;
        if (!cityId) return;

        setLoading(true);
        const response: any = await dispatch(getLocalityList({ city: [cityId] }));
        const districtOptions = response?.data ? toSelectOptions(response.data) : [];
        const prefixes = isSameAsSelected() ? ['per', 'cur'] : ['per'];
        setAddressOptions(prefixes, 'district', districtOptions);
        setLoading(false);
    };

    const fetchCurrentLocality = async (fieldItem?: any, event?: any) => {
        const cityId = event?.value || fieldItem?.value?.value || fieldItem?.value;
        if (!cityId) return;

        setLoading(true);
        const response: any = await dispatch(getLocalityList({ city: [cityId] }));
        const districtOptions = response?.data ? toSelectOptions(response.data) : [];
        setAddressOptions(['cur'], 'district', districtOptions);
        setLoading(false);
    };

    
    // const setPrefillDataOnCheckboxPress = () => {
    //     props?.fields?.forEach((fieldItem: any) => {
    //         prefillSameAsAddress(fieldItem)
    //     })
    // }


   let isShowMinMaxPrice = false;
   // plate no. prefix 
   const platePrefix =
        commonState?.common?.plate_area
            ?.find((val: any) => String(val.value) === String(requestData?.plate_area))
            ?.label?.split("-")[0]?.trim() ||
        (typeof requestData?.plate_area === "string" ? requestData.plate_area.split("-")[0].trim() : "");


   useEffect(() => {
        if (props.sectionIndex !== CREATE_PAGE_INDEX.DOC) return;
        if (!platePrefix) return;
        const plateField = getFieldItem('plate_number');
        if (!plateField) return;

        const currentValue = String(plateField?.value ?? '').trim().toUpperCase();
        const parts = currentValue.split(/\s+/).filter(Boolean);
        const currentPrefix = parts[0] || '';
        const currentSuffix = parts.slice(1).join(' ');

        if (isEdit) {
            if (!currentValue) {
                updateDocItem(plateField, platePrefix, "");
                platePrefillKeyRef.current = platePrefix;
                return;
            }
            if (currentPrefix && currentPrefix !== platePrefix) {
                const nextValue = currentSuffix ? `${platePrefix} ${currentSuffix}` : platePrefix;
                updateDocItem(plateField, nextValue, "");
            }
            platePrefillKeyRef.current = platePrefix;
            return;
        }

        const isNew = +requestData?.vehicle_condition === VEHICLE_CONDITION.NEW;
        const desired = isNew ? `${platePrefix} TBA` : platePrefix;
        const prefillKey = `${platePrefix}|${isNew ? 'new' : 'used'}`;
        const shouldPrefill = platePrefillKeyRef.current !== prefillKey || !currentValue;
        if (!shouldPrefill) return;
        updateDocItem(plateField, desired, "");
        platePrefillKeyRef.current = prefillKey;
   }, [props.sectionIndex, requestData?.vehicle_condition, requestData?.plate_area, platePrefix, props.fields, isEdit]);

    const updateFieldAndResetDependents = (
        sectionItem: any[],
        changedField: string,
        value: any
    ) => {
        const updated = structuredClone(sectionItem);
        const prefix = changedField.split("_")[0];
        const pureFieldName = changedField.replace(`${prefix}_`, "");
        const changedIndex = FIELD_ORDER.indexOf(pureFieldName);

        const isSameAsChecked = getFieldItem('per_sameas_cur')?.value

        for (const section of updated) {
            for (const field of section?.fields) {

                // set current field value
                if (field.name === changedField) {
                    field.value = value;
                }

                // same prefix + next hierarchy reset
                if (field.name.startsWith(prefix + "_")) {
                    const fieldPureName = field.name.replace(`${prefix}_`, "");
                    const fieldIndex = FIELD_ORDER.indexOf(fieldPureName);

                    if (fieldIndex > changedIndex) {
                        field.value = "";
                        field.error_message =""
                    }
                }       

                if ((isSameAsChecked === true || isSameAsChecked === SAME_AS_KTP) && prefix === "per") {
                    const curKey = field.name.replace("per_", "cur_");
                    const curField = section.fields.find((f:any) => f.name === curKey);

                    if (curField) {
                        curField.value = field.value;
                    }
                }
                if(field.value) field['error_message'] = "";   
            }
        }
        return updated;
    };

    /* Fetch master config if not in redux */
    useEffect(() => {
        if (!commonState?.common || Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfigID());
        }
    }, [commonState?.common, dispatch]);

    const insurerBranchList = commonState?.common?.branch_name?.filter(
        (option: any) => +option?.insurer_id === +requestData.insurer_id && +option.status===IS_ACC_TOGGLE.ACTIVE
    ) || [];

    const defaultBranch = insurerBranchList.find(
        (option: any) => +option?.is_hq === IS_HQ
    );

    const [hasUpdated, setHasUpdated] = useState(false);

    // branch id from a field value that can be a number, a string or a {label, value} option
    const getBranchId = (value: any) => (value && typeof value === 'object') ? value?.value : value;

    // The selected branch must belong to the currently selected insurer. In edit mode the Docs form is prefilled
    // with the saved branch of the previous insurer (e.g. Malang); after the insurer is changed on Quote that value
    // is invalid, so replace it with the new insurer's HQ branch (or clear it) in the form state that gets submitted.
    const branchFieldValue = getFieldItem('insurer_branch_id')?.value;
    useEffect(() => {
        if (!requestData?.insurer_id || !commonState?.common?.branch_name) return;
        const branchField = getFieldItem('insurer_branch_id');
        if (!branchField) return;
        const currentId = getBranchId(branchField.value);
        const belongsToInsurer = !!currentId && insurerBranchList.some((option: any) => +option.value === +currentId);
        if (belongsToInsurer) return;
        const nextValue = defaultBranch ? defaultBranch.value : '';
        if (String(currentId ?? '') === String(nextValue)) return;
        props.setSectionItem((prev: any[]) => {
            const updatedSectionItem = structuredClone(prev);
            for (const section of updatedSectionItem) {
                const field = (section?.fields || []).find((item: any) => item.name === 'insurer_branch_id');
                if (field) {
                    field.value = nextValue;
                    field.error_message = "";
                }
            }
            return updatedSectionItem;
        });
        props.setRequestData((prev: any) => ({ ...prev, insurer_branch_id: nextValue || null }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestData?.insurer_id, commonState?.common?.branch_name, getBranchId(branchFieldValue)]);

    useEffect(() => {

        if (
            requestData?.insurer_id !== requestData?.old_insurer_id &&
            !hasUpdated
        ) {

            props.setRequestData((prev: any) => ({
                ...prev,
                insurer_branch_id: defaultBranch?.value,
            }));

            setHasUpdated(true);
        }
    }, [requestData?.insurer_id, requestData?.old_insurer_id]);
 
    useEffect(() => {
        if (props.sectionIndex !== CREATE_PAGE_INDEX.DOC) return;
        const plateField = getFieldItem('plate_number');
        if (!plateField) return;
        const plateValue = String(plateField?.value ?? '').trim().toUpperCase();
        const prefix = String(platePrefix || '').trim().toUpperCase().split(/\s+/)[0] || '';
        const isPrefixOnly = prefix ? plateValue === prefix : (!!plateValue && !/\d/.test(plateValue));
        const errorMsg = getPlateError(plateField?.value ?? '');

        // If submit-time validation set an error for prefix-only, keep it until user edits
        if (isPrefixOnly && plateField?.error_message && !errorMsg) {
            return;
        }

        if ((plateField?.error_message || '') !== errorMsg) {
            updateDocItem(plateField, plateField?.value ?? '', errorMsg);
        }
   }, [props.sectionIndex, requestData?.vehicle_condition, props.fields]);


    useEffect(() => {
        if (props.sectionIndex !== CREATE_PAGE_INDEX.CREATE) return;
        
        if (isEdit) {
            estimatedCarPriceKeyRef.current = "";
            return;
        }

        const params = getEstimatedCarPricePayload();
        if (!params) {
            estimatedCarPriceKeyRef.current = "";
            return;
        }

        const nextKey = JSON.stringify(params);
        if (estimatedCarPriceKeyRef.current === nextKey) return;

        estimatedCarPriceKeyRef.current = nextKey;
        getCarPrice(params);
    }, [
        props.sectionIndex,
        props.fields,
        requestData?.vehicle_category,
        requestData?.vehicle_type,
        requestData?.make_name,
        requestData?.parent_model_name,
        requestData?.version_name,
        requestData?.make_year,
        requestData?.plate_area,
        commonIdState?.newMMVlist?.make_id?.label,
        commonIdState?.newMMVlist?.model_id?.label,
        commonIdState?.newMMVlist?.version_id?.label,
    ]);

    return (
        <>
            {
                props?.fields?.map((fieldItem: any, index: number) => {  
                   
                    // hide fields for policy company
                    if (isCompany && HIDE_FOR_COMPANY.includes(fieldItem.name)) {
                        return null;
                    }

                    if (roleId === ROLE.AGENT && ["application_type", "rule_engine"].includes(fieldItem.name)) {
                        return null;
                    }

                    let inputType = fieldItem?.keyboard_type==='number-pad' && fieldItem?.type!==FIELD_TYPE.CURRENCY?'number':'text'
                    if(fieldItem?.name === 'npwp_no') inputType ='text'
                    const isRtRwField = ['cur_rt', 'per_rt', 'cur_rw', 'per_rw'].includes(fieldItem?.name);
                    const isEngineCapacityInput = isEngineCapacityField(fieldItem);
                    const blockInvalidNumberKeys = (e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                            e.preventDefault();
                        }
                    };
                    if (isEngineCapacityInput) {
                        inputType = 'text';
                    }
                    let optionsList =  getOptionList(fieldItem)
                    if(NUMBER_KEYS?.includes(fieldItem?.name) && fieldItem.value){
                        fieldItem.value = typeof fieldItem?.value === 'number' ? String(fieldItem.value) : fieldItem.value
                    }
                    let optionValue = (typeof fieldItem.value === 'object' || typeof fieldItem.value === 'string') ? fieldItem.value : fieldItem.value != 0 ? optionsList?.filter((option: any) => option.value == fieldItem.value)?.[0] : "";   // eslint-disable-line
                    
                    if(KEYS_WITHOUT_IDS?.includes(fieldItem?.name)){
                        if(optionValue!=""){
                            optionValue = typeof optionValue === 'object' ? optionValue : {
                                label: fieldItem?.value,
                                value: fieldItem?.value
                            }
                        }
                    }
                
                    const isShowField = isShowDynamicField(fieldItem)

                    if(
                        fieldItem?.name === "make_year" 
                        && fieldItem?.value?.value 
                        &&  commonIdState?.newMMVlist?.version_id?.value
                    ){
                        isShowMinMaxPrice = true
                    }

                    if(fieldItem?.name==='insurer_branch_id'){
                        optionsList = insurerBranchList
                        // only show a branch of the currently selected insurer (a branch of the old insurer is dropped)
                        const selectedBranchId = getBranchId(fieldItem?.value);
                        const matchedBranch = selectedBranchId ? insurerBranchList?.find((option: any) => +option.value === +selectedBranchId) : null;
                        optionValue = matchedBranch || defaultBranch || null
                    }

                     const isCalculatingEstimatedTsi = fieldItem?.name === 'car_fmv'
                        && !isEdit
                        && (fieldItem?.value === '' || fieldItem?.value === null || typeof fieldItem?.value === 'undefined');
                    const currencyDisplayValue = isCalculatingEstimatedTsi
                        ? ''
                        : (HELPER.addCurrencyFormatting(getFieldValue(fieldItem)) || '');
                    const currencyPlaceholder = isCalculatingEstimatedTsi ? "Calculating Estimated TSI..." : " ";
                    const materialClassName = isCalculatingEstimatedTsi ? "material tsi-calculating" : "material";
                   
                    
                    switch (fieldItem.type) {
                        
                        case FIELD_TYPE.LABEL:
                            return (
                                <div key={index} className="col-md-12 col-xs-12">
                                    <div className="summery-heading">
                                        <h2>{fieldItem.label}</h2>
                                    </div>
                                </div>
                            );

                        case FIELD_TYPE.CURRENCY:
                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className={materialClassName}>
                                        {
                                            isEnable(fieldItem) ?

                                            <>
                                                <input
                                                    maxLength={DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    placeholder={currencyPlaceholder}
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    value={currencyDisplayValue}
                                                    onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                />
                                                {
                                                    fieldItem?.name==='car_fmv' && isShowMinMaxPrice==true && (
                                                        <span className="tsi-max-min-txt d-block">
                                                            {translations?.CREATE_APP?.TSI_RANGE?.SUGGESTED_RANGE}: {carPrice.min_price===0 ? translations?.CREATE_APP?.TSI_RANGE?.NA : HELPER.addCurrencyFormatting(carPrice.min_price)} - {carPrice.max_price===0 ? translations?.CREATE_APP?.TSI_RANGE?.NA : HELPER.addCurrencyFormatting(carPrice.max_price)} , {translations?.CREATE_APP?.TSI_RANGE?.NOT_RESTRICTED}
                                                        </span>
                        
                                                    )
                                                }
                                            </>
                                                
                                                :
                                                <input
                                                    maxLength={DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    placeholder={currencyPlaceholder}
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    value={currencyDisplayValue}
                                                   onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                />
                                        }
                                        <label data-label={fieldItem.label + (fieldItem.name === 'total_fmv' || fieldItem.is_required ? '' : ((fieldItem?.conditional_mandatory ? '**' : translations?.COMMON_MSG?.OPTIONAL_TAG)))} className="form-label"></label>

                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            )
                           
                        case FIELD_TYPE.TELEPHONE:
                        case FIELD_TYPE.SUM:
                        case FIELD_TYPE.TEXT_BOX: {
                         
                            let dynamicLabel = fieldItem.label;

                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className="material">
                                        {
                                            isEnable(fieldItem) ?
                                        <input
                                            maxLength={fieldItem.type === FIELD_TYPE.MOBILE_FIELD ? 10 : DEFAULT_INPUTFIELD_LENGTH}
                                            disabled={!isEnable(fieldItem)}
                                            type={inputType}
                                            inputMode={isEngineCapacityInput ? "numeric" : undefined}
                                            pattern={isEngineCapacityInput ? "[0-9]*" : undefined}
                                            placeholder=" "
                                            name={fieldItem.name}
                                            className="form-input"
                                            spellCheck={fieldItem.name === 'plate_number' ? false : true}
                                            value={optionValue}
                                            onKeyDown={isEngineCapacityInput ? (e) => HELPER.restrictInvalidNumberKeys(e) : isRtRwField ? blockInvalidNumberKeys : undefined}
                                            onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                        />
                                                :
                                                <input
                                                    maxLength={fieldItem.type === FIELD_TYPE.MOBILE_FIELD ? 10 : DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    inputMode={isEngineCapacityInput ? "numeric" : undefined}
                                                    pattern={isEngineCapacityInput ? "[0-9]*" : undefined}
                                                    placeholder=" "
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    spellCheck={fieldItem.name === 'plate_number' ? false : true}
                                                    value={optionValue}
                                                    onKeyDown={isEngineCapacityInput ? (e) => HELPER.restrictInvalidNumberKeys(e) : isRtRwField ? blockInvalidNumberKeys : undefined}
                                                   onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                />
                                        }
                                        {/* <label data-label={fieldItem.label + (fieldItem.is_required ? '*' : ((fieldItem?.conditional_mandatory ? '**' : '')))} className="form-label"></label> */}
                                        <label data-label={ dynamicLabel +(fieldItem.is_required ? '' : (fieldItem?.conditional_mandatory ? '**' : translations?.COMMON_MSG?.OPTIONAL_TAG))}className="form-label"></label>
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            )
                        }
                        case FIELD_TYPE.MOBILE_FIELD:
                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className="material">
                                        {
                                            isEnable(fieldItem) ?
                                                <input
                                                    maxLength={fieldItem.type === FIELD_TYPE.MOBILE_FIELD ? 10 : DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    placeholder=" "
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    value={getFieldValue(fieldItem) || ''}
                                                  onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                />
                                                :
                                                <input
                                                    maxLength={fieldItem.type === FIELD_TYPE.MOBILE_FIELD ? 10 : DEFAULT_INPUTFIELD_LENGTH}
                                                    disabled={!isEnable(fieldItem)}
                                                    type={inputType}
                                                    placeholder=" "
                                                    name={fieldItem.name}
                                                    className="form-input"
                                                    value={getFieldValue(fieldItem) || ''}
                                                    onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                />
                                        }
                                        <label data-label={fieldItem.label + (fieldItem.is_required ? '' : ((fieldItem?.conditional_mandatory ? '**' : translations?.COMMON_MSG?.OPTIONAL_TAG)))} className="form-label"></label>

                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.FUTURE_DATE:
                              return (
                                isShowField &&
                                <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                    <div className={"material animation-effect" + ((fieldItem.value || fieldItem.name === "expiry_date" ) ? ' active-label' : '')}>
                                        {["effectivity_date", "expiry_date", "received_date"].includes(fieldItem.name) ? (
                                            <ExpiryEffectivityDate
                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                placeholder=""
                                                text={
                                                    fieldItem.name === "effectivity_date"
                                                        ? "Insurance Policy Effectivity Date *"
                                                        : fieldItem.name === "expiry_date"
                                                        ? "Insurance Policy Expiry Date *"
                                                        : `${fieldItem.label} *`
                                                }
                                                insurancePolicyDate={fieldItem?.value}
                                                flag={fieldItem.name}
                                                dateFormat="dd/MM/yyyy"
                                                showTimeSelect={false}
                                                minDate={
                                                    fieldItem.name === "effectivity_date"
                                                        ? pastSixMonths
                                                        : fieldItem.name === "expiry_date"
                                                        ? new Date(minExpiryDate)
                                                        : undefined
                                                }
                                                maxDate={
                                                    fieldItem.name === "effectivity_date" &&
                                                    expiryDateValue &&
                                                    !effectivityDateValue &&
                                                    moment(expiryDateValue).startOf("day").diff(moment().startOf("day").toDate(), "days") <
                                                        EFFECTIVITY_EXPIRY_INTERVAL
                                                        ? new Date(0)
                                                        : fieldItem.name === "received_date"
                                                        ? new Date()
                                                        : undefined
                                                }
                                                {...(fieldItem.name === "expiry_date" ? { effectivity_date: effectivityDateValue || new Date() } : {})}
                                            />
                                        ) : (
                                            <Calendra2
                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                placeholder={fieldItem.label + (fieldItem.is_required ? '' : translations?.COMMON_MSG?.OPTIONAL_TAG)}
                                                dateFormat="dd/MM/yyyy"
                                                selected={fieldItem?.value}
                                                fieldId={fieldItem.id}
                                                fields={props?.fields}
                                                fieldLabel={fieldItem.label}
                                                disabled={!fieldItem.is_enable || fieldItem.name === "insurance_ending_date"}
                                                apptype={4}
                                                fieldname={fieldItem.name}
                                            />
                                        )}
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            );
                        case FIELD_TYPE.DATE_PICKER: {
                            return (
                                isShowField &&
                                <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                    <div className={"material animation-effect" + ((fieldItem.value || fieldItem.name === "expiry_date" ) ? ' active-label' : '')}>
                                        {["effectivity_date", "expiry_date", "received_date"].includes(fieldItem.name) ? (
                                            <ExpiryEffectivityDate
                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                placeholder=""
                                                text={
                                                    fieldItem.name === "effectivity_date"
                                                        ? "Insurance Policy Effectivity Date *"
                                                        : fieldItem.name === "expiry_date"
                                                        ? "Insurance Policy Expiry Date *"
                                                        : `${fieldItem.label} *`
                                                }
                                                insurancePolicyDate={fieldItem?.value}
                                                flag={fieldItem.name}
                                                dateFormat="dd/MM/yyyy"
                                                showTimeSelect={false}
                                                minDate={
                                                    fieldItem.name === "effectivity_date"
                                                        ? pastSixMonths
                                                        : fieldItem.name === "expiry_date"
                                                        ? new Date(minExpiryDate)
                                                        : undefined
                                                }
                                                maxDate={
                                                    fieldItem.name === "effectivity_date" &&
                                                    expiryDateValue &&
                                                    !effectivityDateValue &&
                                                    moment(expiryDateValue).startOf("day").diff(moment().startOf("day").toDate(), "days") <
                                                        EFFECTIVITY_EXPIRY_INTERVAL
                                                        ? new Date(0)
                                                        : fieldItem.name === "received_date"
                                                        ? new Date()
                                                        : undefined
                                                }
                                                {...(fieldItem.name === "expiry_date" ? { effectivity_date: effectivityDateValue || new Date() } : {})}
                                            />
                                        ) : (
                                            <Calendra2
                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                placeholder={fieldItem.label + (fieldItem.is_required ? '' : translations?.COMMON_MSG?.OPTIONAL_TAG)}
                                                dateFormat="dd/MM/yyyy"
                                                selected={fieldItem?.value}
                                                fieldId={fieldItem.id}
                                                fields={props?.fields}
                                                fieldLabel={fieldItem.label}
                                                disabled={!fieldItem.is_enable || fieldItem.name === "insurance_ending_date"}
                                                apptype={4}
                                                fieldname={fieldItem.name}
                                            />
                                        )}
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            );
                        } 
                        case FIELD_TYPE.DATE_TIME: {
                            return (
                                isShowField &&
                                <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                    <div className={"material animation-effect" + (fieldItem.value ? ' active-label' : '')}>
                                        <ExpiryEffectivityDate
                                            onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                            placeholder=""
                                            text={fieldItem.label}
                                            insurancePolicyDate={fieldItem?.value}
                                            flag = {fieldItem.name}
                                        />
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>

                                </fieldset>
                            )
                        }
                        case FIELD_TYPE.RADIO_BOX:
                            return (
                                <div className='form-filed col-md-4 m-xl-b radio-btn existing-loan-fied-radio' key={index + "_radio"}>
                                    <div className='m-lg-r'>
                                        {fieldItem.label} 
                                        {fieldItem.name !== "gender" && ""}
                                    </div>
                                    <div className="loan-radio-outer d-flex p-sm-t">
                                    {
                                        optionsList?.map((option: any, idx: number) => {
                                            return (
                                                
                                                <div key={idx + "_option"} className="custom-control custom-checkbox col-md-6 col-xs-6 ">
                                                    <input checked={optionValue?.value == option?.value} id={'radio' + option.name + "_" + idx} type="radio" className="custom-control-input" name={'radio' + fieldItem.name + "_" + idx} onChange={() => onValueSelect(fieldItem, option)} />
                                                    <label className="custom-control-label">{option.label} </label>
                                                </div>
                                            )
                                        })
                                    }
                                    </div>

                                    
                                    {(fieldItem?.error_message) ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                </div>
                        )


                          case FIELD_TYPE.MUTLI_RADIO_BOX:
                            return (
                                <>
                                <div className={`form-filed ${fieldItem.name === "insurance_type" ? "col-md-12 insurance-type-radio-field" : "col-md-4"} m-xl-b radio-btn existing-loan-fied-radio`} key={index + "_radio"}>
                                    <div className='m-lg-r'>
                                        {fieldItem.label} 
                                        {fieldItem.name !== "gender" && ""}
                                    </div>
                                    {Array.from({
                                        length: fieldItem.name === "insurance_type" ? Math.max(1, Number(tenureYear) || 1) : 1, }).map((_, repeatIndex) => (
                                        <div
                                            className={`loan-radio-outer d-flex p-sm-t ${fieldItem.name === "insurance_type" ? "insurance-type-row" : ""} ${fieldItem.name === "insurance_type" && hasPreviousTloSelection(repeatIndex) ? "insurance-type-row-disabled" : ""}`}  key={`${index}_radio_group_${repeatIndex}`} >
                                        {fieldItem.name === "insurance_type" && (
                                            <span className="insurance-type-year-label">{getOrdinalYearLabel(repeatIndex + 1)}</span>
                                        )}
                                        {
                                            optionsList?.map((option: any, idx: number) => {
                                                const radioId = `radio_${fieldItem.name}_${repeatIndex}_${idx}`;
                                                const radioName = `radio_${fieldItem.name}_${repeatIndex}`;
                                                const isInsuranceTypeField = fieldItem?.name === "insurance_type";
                                                const isFutureTloLocked = isInsuranceTypeField && hasPreviousTloSelection(repeatIndex);
                                                const isOptionSelected = isInsuranceTypeField  ? Number(insuranceValues[repeatIndex]) === Number(option?.value) : optionValue?.value == option?.value;
                                                return (

                                                    <div key={`${repeatIndex}_${idx}_option`} className={`custom-control custom-checkbox col-md-6 col-xs-6 ${isInsuranceTypeField ? "insurance-type-option" : ""} ${isFutureTloLocked ? "insurance-type-option-disabled" : ""} ${isOptionSelected ? "insurance-type-option-selected" : ""}`}  >
                                                        <input 
                                                        checked={isOptionSelected} 
                                                        id={radioId} type="radio" 
                                                        className="custom-control-input" 
                                                        name={radioName} 
                                                        disabled={isFutureTloLocked}
                                                        onChange={() => onValueSelect(fieldItem, option,isInsuranceTypeField ? repeatIndex : '' )} 
                                                        />
                                                        <label className="custom-control-label" htmlFor={radioId}>{option.label} </label>
                                                    </div>
                                                )
                                            })
                                        }
                                        </div>
                                    ))}

                                    {fieldItem?.name === "insurance_type" && Number(tenureYear) > 1 &&
                                    <div className = "p-md-t insurance-type-info">
                                    <i className="ic-info-icon1 m-sm-r"></i>
                                    <span> {translations?.MULTIYEAR?.TLO_SELECTED}</span>
                                    </div>
                                    }
                                    {(fieldItem?.error_message) ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                </div>
                                </>
                            )    

                        case FIELD_TYPE.TEXT_AREA:
                            return (
                                <fieldset className="form-filed col-md-4 textarea-field" key={index}>
                                    <div className={"material"}>
                                        <textarea id="description" placeholder=" " name="notes" className="form-input" value={fieldItem.value} onChange={(e) => {
                                            onValueSelect(fieldItem, e.target.value)
                                        }} />
                                        <label data-label={fieldItem.label} className="form-label"></label>
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.INFO:
                            return (
                                <fieldset className="form-filed col-md-12" key={index}>
                                    <div className={"material"}>
                                        <div className="info-box customer-detail-bg">
                                            <div className="review-info-icn">
                                            <img src={bellIcon} alt=""/>
                                            </div>
                                            <h4>{fieldItem.value}</h4>
                                        </div>
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.MMV:
                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className="material">
                                        {
                                            isEnable(fieldItem) ?
                                                <>
                                                    <input
                                                        maxLength={1000}
                                                        disabled={!isEnable(fieldItem)}
                                                        type={inputType}
                                                        placeholder=" "
                                                        name={fieldItem.name}
                                                        className="form-input"
                                                        value={getFieldValue(fieldItem) || ''}
                                                        onClick={() => handleDependency(fieldItem)}
                                                        onChange={(event) => { onChangeText(fieldItem, event.target.value); }}
                                                    />
                                                    <label data-label={fieldItem.label + (fieldItem.is_required ? '' : translations?.COMMON_MSG?.OPTIONAL_TAG)} className="form-label"></label>
                                                    {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                                </>
                                                : null
                                        }
                                    </div>
                                </fieldset>
                        )
                        case FIELD_TYPE.TITLE: return (
                            <div className="col-md-12">
                                <h3>{fieldItem.label}</h3>
                            </div>
                        )
                        case FIELD_TYPE.SWITCH: return (
                            <div className="col-md-12">
                        <div className={`additioal-access-outer ${ props.sectionIndex === CREATE_PAGE_INDEX.DOC ? "doc-radio" : ""}`}>
                            <div className="additioal-access-heading">
                                 {props.sectionIndex === CREATE_PAGE_INDEX.CREATE  ? <h3>{translations?.CREATE_APP?.ADDITIONAL_ACCESSORIES}</h3> :<h3>{`${translations?.CREATE_APP?.SAME_AS_COMPANY_ADDRESS}*`}</h3> }
                               
                                <div className="on-off-switch">
                                    <ToggleSwitch 
                                    onValueSelect={onValueSelect} 
                                    fieldItem={fieldItem}/>
                                </div>
                            </div>
                            {/* <span className="add-more-acces-txt">Add More Accessories</span> */}

                        </div>
                    </div>
                        )

                        default: {
                            return (

                                isShowField &&
                                <React.Fragment key={index} >
                                    {
                                        isEnable(fieldItem) ?
                                            <ReactSelect
                                                options={optionsList}
                                                value={optionValue}
                                                handleChange={(e: any, fieldKey: string) => onValueSelect(fieldItem, e)}
                                                onClick ={()=>handleDependency(fieldItem)}
                                                placeholder={fieldItem.label + ((fieldItem.is_required) ? '' : translations?.COMMON_MSG?.OPTIONAL_TAG)}
                                                fieldKey=""
                                                fieldItemName={fieldItem.name}
                                                isDisabled={!isEnable(fieldItem)}
                                                errorField={fieldItem?.error_message}
                                                fieldSetClassName={"form-filed " + rowClass}
                                                note={fieldItem?.note || ""}

                                            />
                                            :
                                            <ReactSelect
                                                options={optionsList}
                                                value={optionValue}
                                                placeholder={fieldItem.label + ((fieldItem.is_required) ? '' : translations?.COMMON_MSG?.OPTIONAL_TAG)}
                                                fieldKey=""
                                                isDisabled={!isEnable(fieldItem)}
                                                errorField={fieldItem?.error_message}
                                                fieldSetClassName={"form-filed " + rowClass}
                                            />
                                    }

                                </React.Fragment>
                            )
                        }
                    }
                })
            }
            <MMVModal show={showMMVPopup} type={mmvModalType} handleClose={() => {
                setShowMMVPopup(false)
                setRefresh(!refresh)
            }} vehicleUsage={getFieldItem('vehicle_classification')?.value?.vehicle_usage} setType={setMMVModalType} setEngineCapacity={setEngineCapacity} setFieldItemValue={(value: any) => {
                const oldItem = getFieldItem('vehicle')
                oldItem['value'] = value
            }} 
            fetchMMV={fetchMMV}
            updateItem={updateItem}
            sectionIndex={sectionIndex}
            />
        </>
    )
}
